import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCComponent } from './simple-icons-c.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCComponent ],
    exports:      [ SimpleIconsCComponent ],
    bootstrap:    []
})
export class SimpleIconsCModule {}
